// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"I-z","pointsSection":"J-z","goToDashboard":"K-z"};